import { defineNuxtPlugin } from '#app'
// @ts-ignore
import LvlSpinner from '@/ui-core/components/spinner'
import { Dialog } from './dialog'
import type { Options } from './types'

export default defineNuxtPlugin(nuxtApp => {
  Dialog.setDefaultOptions({
    wrapper: defineAsyncComponent(
      () => import('@/components/common/dialog/content-wrapper.vue')
    ),
    loading: LvlSpinner
  })

  return {
    provide: {
      dialog: (options?: Options) => new Dialog(nuxtApp.vueApp, options)
    }
  }
})
